import React from 'react';
import { Box, Avatar, Typography, Chip } from '@mui/material';

const STATUS_COLOR = { active: 'success', suspended: 'error', archived: 'default' };

const buildGACompanyColumns = ({ t }) => [
  {
    field: 'companyName',
    headerName: t('Company Name'),
    flex: 1.6,
    minWidth: 220,
    renderCell: (params) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
        <Avatar variant="rounded" sx={{ width: 32, height: 32, bgcolor: 'primary.light', color: 'primary.dark' }}>
          {params.value ? params.value.trim().charAt(0).toUpperCase() : '?'}
        </Avatar>
        <Typography variant="subtitle2" noWrap>{params.value}</Typography>
      </Box>
    ),
  },
  {
    field: 'status',
    headerName: t('Status'),
    flex: 0.7,
    minWidth: 110,
    renderCell: (params) => {
      const status = params.value || 'active';
      return <Chip label={t(`ga.status.${status}`, { defaultValue: status })} color={STATUS_COLOR[status] || 'default'} size="small" />;
    },
  },
  {
    field: 'usersCount',
    headerName: t('Users'),
    flex: 0.6,
    minWidth: 90,
    type: 'number',
  },
  {
    field: 'ordersCount',
    headerName: t('Orders'),
    flex: 0.6,
    minWidth: 90,
    type: 'number',
  },
  {
    field: 'companyEmail',
    headerName: t('Email'),
    flex: 1.2,
    minWidth: 200,
  },
];

export default buildGACompanyColumns;
